<script lang="ts">
	import md from '$lib/utils/md';
	import { getCopy } from '$lib/lang/copy.svelte';
	import Section from '$lib/components/fragments/Section.svelte';
	import Headline from '$lib/components/fragments/Headline.svelte';
	import Callout from '$lib/components/fragments/Callout.svelte';

	const copy = $derived(getCopy().horizon);
</script>

<Section id="future" class="bg-blue text-white">
	<div class="content-well-sm relative flex flex-col gap-10">
		<Headline overline={copy.overline} title={copy.title} dark />
		<p class="body-1">{@html md(copy.copy_before)}</p>
	</div>

	<Callout
		image={{
			src: 'globalShift2.webp',
			alt: copy.callout.alt,
			classes: 'max-w-[250px] md:max-w-[350px] w-full'
		}}
	>
		<div class="heading-6 callout-content text-center md:text-left">
			{@html md(copy.callout.text)}
		</div>
		<a
			href={copy.callout.source.href}
			class="text-yellow microcopy-2 mt-5 block text-center font-bold underline md:mt-10 md:text-left"
			>{copy.callout.source.label}</a
		>
	</Callout>

	<div class="content-well-sm">
		<p class="body-1">{@html md(copy.copy_after)}</p>
	</div>
</Section>

<style lang="postcss">
	@reference '$lib/styles/app.css';

	.callout-content {
		:global(.markdown) {
			@apply gap-2;
		}

		:global(span) {
			@apply text-yellow heading-2;
		}
	}
</style>
